import * as React from "react"
import {useCallback, useEffect} from "react" // Agregamos useCallback
import {ButtonIconSeeker} from "@ui-seeker/core";


export default function RawMatcherImageComparisonModalArrow({ brandOptionsLength, localIndex, orientation = 'left', onNavigate }) {
    const isLeft = orientation === 'left';
    const validKey = isLeft ? 'ArrowLeft' : 'ArrowRight';

    const handleKeyDown = useCallback((e) => {
       if (e.key === validKey) {
          e.preventDefault();
          onNavigate(); // Llama al handler que viene del padre/hook
       }
    }, [validKey, onNavigate]); // Depende del validKey y del callback onNavigate

    useEffect(() => {
       window.addEventListener('keydown', handleKeyDown);
       return () => window.removeEventListener('keydown', handleKeyDown);
    }, [handleKeyDown]);

    const isDisabled = isLeft
       ? !brandOptionsLength || localIndex <= 0
       : !brandOptionsLength || localIndex >= (brandOptionsLength - 1);

    return <ButtonIconSeeker
       icon={`chevron-${orientation}`}
       size="medium"
       onClick={onNavigate}
       disabled={isDisabled}
       sx={{
          position: 'absolute',
          top: '50%',
          transform: 'translateY(-50%)',
          zIndex: 2,
          bgcolor: 'background.paper',
          ...isLeft ? { left: 8 } : { right: 8 }
       }}
    />
}